import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Биология. 10 класс.",
        subject: "Биосинтез белка. Реакции матричного синтеза",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Биосинтез белка. Реакции матричного синтеза",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Овчинников Алексей Васильевич",
                grade: "кандидат педагогических наук",
                subGrade: "",
                imageSrc: "./images/author1.jpg"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>" +
                                "<p>Урок на тему «Биосинтез белка. Реакции матричного синтеза» является одним из уроков темы «Жизнедеятельность клетки», в ходе которой рассматриваются особенности пластического и энергетического обменов клетки. </p>" +
                                "</div>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>На изучение биосинтеза белка, ввиду большого объёма и высокой сложности изучаемого материала, отводится два урока, связанных между собой единым содержанием. Исходя из этого, материалы данного кейса содержат рекомендации по изучению всей темы «Биосинтез белка. Реакции матричного синтеза», без деления её на отдельные уроки. При необходимости учитель может использовать их как при одночасовом, так и при двухчасовом изучении темы. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Трудности в изучении данной темы связаны с тем, что обучающимся необходимо освоить значительное число терминов и понятий: ген, генетический код, матричный синтез, транскрипция, трансляция, кодон, антикодон, рибосома, центральная догма молекулярной биологии, а также уметь определять свойства генетического кода, описывать этапы реализации наследственной информации в клетке, сравнивать реакции матричного синтеза молекул РНК и белка в клетке.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Кроме того, объекты и процессы, изучаемые на данном уроке, чаще всего недоступны для непосредственного наблюдения, в связи с чем, при изучении темы, велика роль приёмов абстрагирования, моделирования, визуализации.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Успешность в достижении результатов урока определяется необходимостью организации различных видов деятельности обучающихся, высокой плотностью и темпом урока, использованием различных источников информации, погружением в исторический контекст, чередованием фронтальных и индивидуальных форм работы учителя и обучающихся.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Эти особенности конструирования урока будут представлены в основном содержании кейса. Использование материалов кейса позволяет успешно достигать предметных, метапредметных и личностных результатов изучения темы «Биосинтез белка. Реакции матричного синтеза».</p>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video_b.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Агафонова И.Б. Сивоглазов В. И. Биология. Общая биология. Базовый уровень. 10-11 кл. В 2 ч.  Ч. 1: рабочая тетрадь  к учебнику В. И. Сивоглазова, И. Б. Агафоновой, Е. Т. Захаровой «Биология. Общая биология. Базовый уровень. 10-11 классы / И. Б. Агафонова, В. И. Сивоглазов, Я.В. Котелевская. – 2-е изд., стереотип. – Москва: Дрофа, 2011",
                "Лернер Г.И. Курс «Педагогическая теория – современному учителю». – Биология [журнал], №37, 2004",
                "Сивоглазов В. И. Биология. Общая биология. Базовый уровень [Текст]: учеб. для 10-11 кл. общеобразоват. учреждений / В. И. Сивоглазов,  И. Б. Агафонова, Е. Т. Захарова; под ред. акад. РАЕН, проф. В. Б. Захарова. – Москва: Дрофа, 2010",
                "Вахрушев А.А. Биология. 10–11 кл.: учеб. для организаций, осуществляющих образовательную деятельность. Базовый уровень / А.А. Вахрушев, О.В. Бурский, А.С. Раутиан, Е.И. Родионова, М.Н. Розанов. – Москва: Баласс, 2015"
            ],
            filesToDownload: [
                {
                    link: "./files/task.pdf",
                    fileName: "Задачи по теме \"Биосинтез белка\""
                }
            ]
        }
    ],
};
